export default {
  // Thủ trưởng từ chối duyệt
  CompanyDirectorReject: -2,
  // Kế toán trưởng từ chối duyệt
  CompanyChiefAccountantReject: -1,
  // Chờ thủ trưởng duyệt
  WaitingCompanyDirector: 2,
  // Thủ trưởng đã duyệt
  CompanyDirectorApproved: 3,
  // Hồ sơ đã được gửi cho ủy quyền KTT duyệt
  DelegateReject: 99
};
